module.exports = __webpack_public_path__ + "img/md-item10.30efe3a.png";